import { useQuery } from "@tanstack/react-query";
import { ShieldAlert } from "lucide-react";

import { orpc } from "@/client";
import { SystemLabels } from "@/lib/labels/system";

export function RehearsalBanner() {
	const { data } = useQuery(orpc.send.config.queryOptions());

	if (data === undefined || data.enabled) {
		return null;
	}

	return (
		<div
			data-component="rehearsal-banner"
			className="mb-5 flex items-center gap-2 border-l-2 border-warning bg-warning-soft px-3 py-2 text-xs font-medium text-warning"
		>
			<ShieldAlert className="size-4 shrink-0" />
			{SystemLabels.rehearsalBanner}
		</div>
	);
}
